import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const DocumentVerificationSummary = ({ verifications, t }) => {
  const getEntityOccurrence = verifications => {
    return Object.entries(
      verifications.reduce((occ, o) => {
        occ[o.partnerName] = (occ[o.partnerName] || 0) + 1;
        return occ;
      }, {})
    );
  };

  const getStatusOccurrence = verifications => {
    return Object.entries(
      verifications.reduce((occ, o) => {
        occ[o.status] = (occ[o.status] || 0) + 1;
        return occ;
      }, {})
    );
  };

  return (
    <div>
      {getEntityOccurrence(verifications).map((entity, index) => {
        const partnerVerifications = verifications.filter(x => x.partnerName === entity[0]);
        return (
          <Grid container pt={1} key={index}>
            <Grid item xs={12} sm={2} md={4}>
              <span style={{ fontWeight: 'bold' }}>
                {t('DocumentEdit.Verification.Header')} {entity[0]}
              </span>
              : <span>{entity[1]}</span>
            </Grid>
            {getStatusOccurrence(partnerVerifications).map((status, idx) => {
              return (
                <Grid item xs={12} sm={2} md={2} key={idx}>
                  <span style={{ fontWeight: 'bold' }}> {status[0]} </span> : <span>{status[1]}</span>
                </Grid>
              );
            })}
          </Grid>
        );
      })}
    </div>
  );
};

DocumentVerificationSummary.propTypes = {
  verifications: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(DocumentVerificationSummary);
